"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdePatchPatientDtoToJSON = exports.AdePatchPatientDtoFromJSONTyped = exports.AdePatchPatientDtoFromJSON = exports.instanceOfAdePatchPatientDto = void 0;
var runtime_1 = require("../runtime");
var BiologicalSex_1 = require("./BiologicalSex");
var CreatePatientContactInfoDto_1 = require("./CreatePatientContactInfoDto");
var CreatePatientPreferencesDto_1 = require("./CreatePatientPreferencesDto");
/**
 * Check if a given object implements the AdePatchPatientDto interface.
 */
function instanceOfAdePatchPatientDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdePatchPatientDto = instanceOfAdePatchPatientDto;
function AdePatchPatientDtoFromJSON(json) {
    return AdePatchPatientDtoFromJSONTyped(json, false);
}
exports.AdePatchPatientDtoFromJSON = AdePatchPatientDtoFromJSON;
function AdePatchPatientDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'contactInfo': !(0, runtime_1.exists)(json, 'contactInfo') ? undefined : (0, CreatePatientContactInfoDto_1.CreatePatientContactInfoDtoFromJSON)(json['contactInfo']),
        'preferences': !(0, runtime_1.exists)(json, 'preferences') ? undefined : (0, CreatePatientPreferencesDto_1.CreatePatientPreferencesDtoFromJSON)(json['preferences']),
        'ethnicity': !(0, runtime_1.exists)(json, 'ethnicity') ? undefined : json['ethnicity'],
        'dob': !(0, runtime_1.exists)(json, 'dob') ? undefined : json['dob'],
        'deceased': !(0, runtime_1.exists)(json, 'deceased') ? undefined : json['deceased'],
        'deceasedDate': !(0, runtime_1.exists)(json, 'deceasedDate') ? undefined : json['deceasedDate'],
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : json['gender'],
        'biologicalSex': !(0, runtime_1.exists)(json, 'biologicalSex') ? undefined : (0, BiologicalSex_1.BiologicalSexFromJSON)(json['biologicalSex']),
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'middleName': !(0, runtime_1.exists)(json, 'middleName') ? undefined : json['middleName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
        'middleInitial': !(0, runtime_1.exists)(json, 'middleInitial') ? undefined : json['middleInitial'],
        'mrn': !(0, runtime_1.exists)(json, 'mrn') ? undefined : json['mrn'],
        'suffix': !(0, runtime_1.exists)(json, 'suffix') ? undefined : json['suffix'],
        'patientId': !(0, runtime_1.exists)(json, 'patientId') ? undefined : json['patientId'],
    };
}
exports.AdePatchPatientDtoFromJSONTyped = AdePatchPatientDtoFromJSONTyped;
function AdePatchPatientDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'contactInfo': (0, CreatePatientContactInfoDto_1.CreatePatientContactInfoDtoToJSON)(value.contactInfo),
        'preferences': (0, CreatePatientPreferencesDto_1.CreatePatientPreferencesDtoToJSON)(value.preferences),
        'ethnicity': value.ethnicity,
        'dob': value.dob,
        'deceased': value.deceased,
        'deceasedDate': value.deceasedDate,
        'gender': value.gender,
        'biologicalSex': (0, BiologicalSex_1.BiologicalSexToJSON)(value.biologicalSex),
        'firstName': value.firstName,
        'middleName': value.middleName,
        'lastName': value.lastName,
        'middleInitial': value.middleInitial,
        'mrn': value.mrn,
        'suffix': value.suffix,
        'patientId': value.patientId,
    };
}
exports.AdePatchPatientDtoToJSON = AdePatchPatientDtoToJSON;
